import { Carousel, Col, Container, Row } from "react-bootstrap";
import Card from "../../views/card/card";
import Title from "../../views/title/title";
import Text from "../../views/text/text";
import Button from '../../views/button/button';
import './pricing.css'
import './pricing-sm.css'
import { useState } from "react";
import gtag from "../../core/utils/gtag";

function Pricing() {

    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    const getStartedHandler = (tier) => () => {
        gtag.event('pricing_get_started_clicked', {
            'tier': tier
        });
        window.location.href = "/register?t=" + tier;
    }
    return(
        <>
            <Container className="pricing" id="pricing" >
                <Row className="pricing-title">
                    <section><Title>Our pricing structure<strong>is inclusive of all company sizes.</strong></Title></section>
                    <section><Text thin>Need more details about pricing? <a href="#contact">Contact us!</a></Text></section>
                </Row>
                <Row className="d-none d-md-block d-lg-none">

                    <Carousel activeIndex={index} onSelect={handleSelect} variant="dark">
                        <Carousel.Item>
                            <Card>
                                <section className="price-model"><Title type="sub"><strong>Startup</strong></Title></section>
                                <section><Text thin para>0 - 10 active clients or employees/mo</Text></section>
                                <section className="pricing-features">
                                    <ul>
                                        <li><Text thin>Mobile Attendance</Text></li>
                                        <li><Text thin>Scheduler</Text></li>
                                        <li><Text thin>Employee Compliance Processing</Text></li>
                                        <li><Text thin>Billing</Text></li> 
                                    </ul>
                                </section>
                                <section className="price-section">
                                    <span className="price-figure"><sup className="price-sign">$</sup>199</span>
                                    <span className="price-month">/month</span>
                                </section>
                                <section className="fine-print">
                                    A registration fee is required
                                </section>
                                <section className="price-button">
                                    <Button large onClick={getStartedHandler('t1')}>Get Started</Button>
                                </section>
                            </Card>
                        </Carousel.Item>

                        <Carousel.Item>
                            <Card>
                                <div className="price-highlight">
                                    <section className="price-model"><Title type="sub"><strong>Growth</strong></Title></section>
                                    <section><Text thin color="#FFFFFF">11-50 active clients or employees/mo</Text></section>
                                </div>
                                <section className="pricing-features">
                                    <ul>
                                        <li><Text thin>Startup Basics</Text></li>
                                        <li><Text thin>Concierge Onboarding</Text></li>
                                        <li><Text thin>Benefits Programming</Text></li>
                                        <li><Text thin>Client CRM System</Text></li>
                                    </ul>
                                </section>
                                <section className="price-section">
                                    <span className="price-figure"><sup className="price-sign">$</sup>499</span>
                                    <span className="price-month">/month</span>
                                </section>
                                <section className="fine-print">
                                    A registration fee is required
                                </section>
                                <section className="price-button price-btn-highlight">
                                    <Button large onClick={getStartedHandler('t2')}>Get Started</Button>
                                </section>
                            </Card>
                        </Carousel.Item>

                        <Carousel.Item>
                            <Card>
                                <section className="price-model"><Title type="sub"><strong>Workforce</strong></Title></section>
                                <section><Text thin para>for organization with more than 50 clients or employees  </Text></section>
                                <section className="pricing-features">
                                    <ul>
                                        <li><Text thin>Workforce Basics</Text></li>
                                        <li><Text thin>Custom Reporting</Text></li>
                                        <li><Text thin>Website Integration</Text></li>
                                        <li><Text thin>System Review</Text></li>
                                    </ul>
                                </section>
                                <section className="price-section">
                                    <span className="price-figure"><sup className="price-sign">$</sup>10</span>
                                    <span className="price-month">/active resource</span>
                                </section>
                                <section className="fine-print">
                                    A registration fee is required
                                </section>
                                <section className="price-button">
                                    <Button large onClick={getStartedHandler('t3')}>Get Started</Button>
                                </section>
                            </Card>
                        </Carousel.Item>
                    </Carousel>

                </Row>
                <Row className="justify-content-center d-lg-flex d-md-none">
                    <Col lg="4" className="margin-botton-sm">
                        <Card>
                            <section className="price-model"><Title type="sub"><strong>Startup</strong></Title></section>
                            <section><Text thin para>0 - 10 active clients or employees/mo</Text></section>
                            <section className="pricing-features">
                                <ul>
                                    <li><Text thin>Mobile Attendance</Text></li>
                                    <li><Text thin>Scheduler</Text></li>
                                    <li><Text thin>Employee Compliance Processing</Text></li>
                                    <li><Text thin>Billing</Text></li>
                                </ul>
                            </section>
                            <section className="price-section">
                                <span className="price-figure"><sup className="price-sign">$</sup>199</span>
                                <span className="price-month">/month</span>
                            </section>
                            <section className="fine-print">
                                A registration fee is required
                            </section>
                            <section className="price-button">
                                <Button large onClick={getStartedHandler('t1')}>Get Started</Button>
                            </section>
                        </Card>
                    </Col>
                    <Col lg="4" className="margin-botton-sm">
                        <Card>
                            <div className="price-highlight">
                                <section className="price-model"><Title type="sub"><strong>Growth</strong></Title></section>
                                <section><Text thin color="#FFFFFF">11-50 active clients or employees/mo</Text></section>
                            </div>
                            <section className="pricing-features">
                                <ul>
                                    <li><Text thin>Startup Basics</Text></li>
                                    <li><Text thin>Concierge Onboarding</Text></li>
                                    <li><Text thin>Benefits Programming</Text></li>
                                    <li><Text thin>Client CRM System</Text></li>
                                </ul>
                            </section>
                            <section className="price-section">
                                <span className="price-figure"><sup className="price-sign">$</sup>499</span>
                                <span className="price-month">/month</span>
                            </section>
                            <section className="fine-print">
                                A registration fee is required
                            </section>
                            <section className="price-button price-btn-highlight">
                                <Button large onClick={getStartedHandler('t2')}>Get Started</Button>
                            </section>
                        </Card>
                    </Col>
                    <Col lg="4" className="margin-botton-sm">
                        <Card>
                            <section className="price-model"><Title type="sub"><strong>Workforce</strong></Title></section>
                            <section><Text thin para>for organization with more than 50 clients or employees  </Text></section>
                            <section className="pricing-features">
                                <ul>
                                    <li><Text thin>Workforce Basics</Text></li>
                                    <li><Text thin>Custom Reporting</Text></li>
                                    <li><Text thin>Website Integration</Text></li>
                                    <li><Text thin>System Review</Text></li> 
                                </ul>
                            </section>
                            <section className="price-section">
                                <span className="price-figure"><sup className="price-sign">$</sup>10</span>
                                <span className="price-month">mo/active resource</span>
                            </section>
                            <section className="fine-print">
                                A registration fee is required
                            </section>
                            <section className="price-button">
                                <Button large onClick={getStartedHandler('t3')}>Get Started</Button>
                            </section>
                        </Card>
                    </Col>
                </Row>

            </Container>
        </>
    );
}

export default Pricing;